<template>
  <div class="modal-header">
    <div class="container px-0">
      <div class="modal-title">
        Conferma città di partenza
      </div>
      <button type="button" class="close" data-dismiss="modal">
        <div class="close-span">
          CHIUDI
          <div class="icon icon-cross" aria-hidden="true"/>
        </div>
      </button>
    </div>
  </div>
  <div class="modal-body container select-city-modal">
    <div class="row">
      <div class="col-xl-6 col-lg-8 col-md-9 col-12 h-100 mx-auto information-box modal-centered">
        <div class="extension-title">Conferma la città di partenza</div>
        <p class="modal-description">
            Per procedere con il preventivo, ti chiediamo di confermare la città di partenza oppure di tornare indietro per modificarla.
        </p>

        <div class="city-box dropdown">
          <div class="city">
            <div class="icon icon-city_small"></div>
            <div class="city-name">
              <div class="name">{{this.selectedCity && this.selectedCity !== '' ? this.selectedCity : 'Milano(MI)'}}</div>
              <div class="sub">Città di partenza</div>
            </div>
          </div>
          <div class="help dropleft">
            <button type="button" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">Come modificare?</button>
            <div v-html="this.assets.selectCityModal[this.origin]"></div>
          </div>
        </div>

        <div class="button-box">
          <button type="button" class="close" v-on:click="this.closeModal($event)">
            <div class="close-span">
              Modifica
            </div>
          </button>
          <a v-bind:href="this.modal.data.confirmUrl" type="button" class="btn btn-primary background-gold3 text-uppercase confirm-button">Conferma</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  props: [
    'origin'
  ],
  name: "selectCityModal",
  computed: {
    ...mapState([
      'modal',
      'assets',
      'selectedCity'
    ])
  },
  methods: {
    closeModal: function(event) {
      let closeButton = $(event.target);
      let modalElement = closeButton.closest('.modal');
      let inputElement = document.getElementById('plp_lp');

      modalElement.modal('hide');

      $(inputElement)[0].scrollIntoView();

      inputElement.focus();
    }
  }
}
</script>
